import React from 'react';
import PropTypes from 'prop-types';
import { validateFunctions } from './validatorFunctions';

let errorBoolean,
  copiaArray = [];
/** 
 A validator component with prebuilt rules to quickly validate input components and display custom error messages, 
 *you can also add new rules and mesages with a regExpr.
*/
class Validator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorMsg: '',
      required: false,
      errorsCache: [],
      inputValue: ''
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(ev) {
    let options = this.props.options;
    let optionsKey;
    this.setState({ inputValue: ev.target.value });
    let contador = 0;
    for (var key in options) {
      contador++;
      if (options.hasOwnProperty(key)) {
        switch (key) {
          case 'required':
            if (ev.target.value.length === 0) {
              errorBoolean = true;
              optionsKey = options[key];
              if (errorBoolean) {
                copiaArray.push({
                  errorBoolean,
                  optionsKey: { errorMsg: options.required }
                });
              }
            }
            break;
          case 'email':
            errorBoolean = validateFunctions.email(ev);
            optionsKey = options[key];
            if (errorBoolean) {
              copiaArray.push({
                errorBoolean,
                optionsKey: { errorMsg: options.email }
              });
            }
            break;
          case 'minLength':
            if (ev.target.value.length <= options.minLength.value) {
              errorBoolean = true;
              if (errorBoolean) {
                copiaArray.push({
                  errorBoolean,
                  optionsKey: { errorMsg: options.minLength.errorMsg }
                });
              }
            }
            break;
          default:
            errorBoolean = validateFunctions.regularExpression(
              ev,
              options[key]
            );
            optionsKey = options[key];
            if (errorBoolean) {
              copiaArray.push({ errorBoolean, optionsKey });
            }
            break;
        }
      }
    }
    if (copiaArray.length > 0) {
      copiaArray.map(el => {
        if (el.errorBoolean) {
          errorBoolean = el.errorBoolean;
          this.setState({
            error: true,
            errorMsg: el.optionsKey.errorMsg
          });
        }
      });
    } else {
      this.setState({ error: false, errorMsg: copiaArray.er });
    }
    this.props.onChange(ev, errorBoolean);
  }
  render() {
    copiaArray = [];
    return this.props.render(this.props, this.state, this.handleChange);
  }
}

Validator.propTypes = {
  /** an object to add custome validations and messages, the order you place the options matters, if two or more error messages are true at the same time, the last options you add will overwrite previous options. */
  options: PropTypes.object,
  /** displays an error message when an email input is incorrect*/
  'options.email': PropTypes.string,
  /** displays an error message when the input has not been filled */
  'options.required': PropTypes.string,
  /** displays an error message when the input's length is less than value property
   * {
   *  minLength : {value : 3, errorMsg : "minLength error message"},
   * }
   */
  'options.minLength': PropTypes.object,
  /** an object to add custom errors with regExpr, change customName for any name you like, for example if you want to validate only numbers in an input :  {onlyNumbers : {value : /[0-9]/g, errorMsg : "custom error with regExpr" }}    */
  'options.customName': PropTypes.object,
  /** an onChange event that fires when the child component changes, you can access ev properties and the error boolean which indicate if there is an error*/
  'onChange(ev, errorBoolean)': PropTypes.func
};

export { Validator };
